/**
 *  @class
 *  @function ProductVerification
 */
if (!customElements.get('product-verification')) {
  class ProductVerification extends HTMLElement {
    constructor() {
      super();

      this.mode = this.dataset.mode;
      this.endpoint = this.dataset.endpoint;
      this.codeLength = parseInt(this.dataset.codeLength, 10) || 0;
    }

    connectedCallback() {
      this.form = this.querySelector('form');
      this.input = this.querySelector('.product-verification--code');
      this.button = this.querySelector('.button');
      this.counter = this.querySelector('.product-verification--counter');
      this.result = this.querySelector('.product-verification--result');
      this.embed = this.querySelector('.product-verification--embed iframe');

      const code = ProductVerification.codeFromUrl();

      if (this.mode === 'widget') {
        this.loadWidget(code);
        return;
      }

      this.form.addEventListener('submit', this.onSubmit.bind(this));
      this.input.addEventListener('input', this.onInput.bind(this));

      if (code) {
        this.input.value = ProductVerification.normalize(code);
        this.onInput();
        this.verify(this.input.value);
      }
    }

    /**
     * The verification widget auto-checks a code passed as ?c=, which is what
     * the QR codes printed on the packaging link to.
     */
    loadWidget(code) {
      if (!this.embed || !code) return;

      const src = this.embed.src;
      this.embed.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'c=' + encodeURIComponent(code);
    }

    onInput() {
      const value = ProductVerification.normalize(this.input.value);

      if (this.input.value !== value) {
        this.input.value = value;
      }
      if (this.counter && this.codeLength) {
        this.counter.textContent = value.length + '/' + this.codeLength;
      }
    }

    onSubmit(event) {
      event.preventDefault();

      const code = ProductVerification.normalize(this.input.value);

      if (!code || (this.codeLength && code.length !== this.codeLength)) {
        this.render('error', this.dataset.textInvalid);
        this.input.focus();
        return;
      }
      this.verify(code);
    }

    async verify(code) {
      this.setLoading(true);

      try {
        const response = await fetch(this.endpoint + '?code=' + encodeURIComponent(code), {
          headers: { Accept: 'application/json' }
        });
        const data = await response.json();

        if (data.code === 1000) {
          this.render('success', (data.data && data.data.tips) || this.dataset.textSuccess, this.dataset.textSuccessTitle);
          ProductVerification.updateUrl(code);
        } else {
          this.render('error', data.msg || this.dataset.textNotFound);
        }
      } catch (e) {
        this.render('error', this.dataset.textNetworkError);
      }

      this.setLoading(false);
    }

    setLoading(loading) {
      this.dataset.state = loading ? 'loading' : '';
      this.button.classList.toggle('loading', loading);
      this.button.setAttribute('aria-busy', loading);
    }

    render(status, message, title) {
      const wrapper = document.createElement('div'),
        icon = this.querySelector('.product-verification--icon-' + status),
        text = document.createElement('div');

      wrapper.className = 'product-verification--message is-' + status;

      if (icon) {
        wrapper.appendChild(icon.content.cloneNode(true));
      }
      if (title) {
        const heading = document.createElement('strong');
        heading.textContent = title;
        text.appendChild(heading);
      }
      const paragraph = document.createElement('p');
      paragraph.textContent = message;
      text.appendChild(paragraph);
      wrapper.appendChild(text);

      this.result.replaceChildren(wrapper);
    }

    static normalize(value) {
      return value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
    }

    static codeFromUrl() {
      const params = new URLSearchParams(window.location.search);
      return params.get('c') || params.get('code') || '';
    }

    static updateUrl(code) {
      const url = new URL(window.location.href);
      url.searchParams.set('c', code);
      window.history.replaceState({}, '', url);
    }
  }
  customElements.define('product-verification', ProductVerification);
}
